<template>
  <div class="wrap">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="配置" name="first">
        <option-list />
      </el-tab-pane>
      <el-tab-pane label="监控记录" name="second">
        <record-list />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import optionList from './components/option';
import recordList from './components/record';
export default {
  name: 'SensitiveWords',
  components: { optionList, recordList },
  props: {},
  data() {
    return {
      activeName: 'first',
    };
  },
  computed: {},
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped></style>
